if (!customElements.get('video-showcase-component')) {
  customElements.define(
    'video-showcase-component',
    class VideoShowcase extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.swipeMobile = this.dataset.swipeMobile === 'true';

        // No JavaScript needed - just let CSS handle everything
        // The swipe-mobile classes are already in the HTML
      }
    }
  );
}
